import { render, staticRenderFns } from "./wemeidaConfig.vue?vue&type=template&id=04622330&scoped=true"
import script from "./wemeidaConfig.vue?vue&type=script&lang=js"
export * from "./wemeidaConfig.vue?vue&type=script&lang=js"
import style0 from "./wemeidaConfig.vue?vue&type=style&index=0&id=04622330&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04622330",
  null
  
)

export default component.exports